import React from 'react';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToBooking = () => {
    document.getElementById('booking-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-[#1a1a1a] text-white pt-24 pb-20 min-h-[80vh] flex flex-col justify-between overflow-hidden" data-id="element-78">
      <div className="container mx-auto px-4 md:px-8 relative z-10" data-id="element-79">
        <nav className="flex justify-between items-center mb-16" data-id="element-80">
          <div className="text-2xl font-bold font-['Caveat']" data-id="element-81">Beep Books</div>
          <Button variant="primary" className="text-sm px-4 py-2" onClick={scrollToBooking} data-id="element-82">
            Book Now
          </Button>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20" data-id="element-83">
          <div className="max-w-xl" data-id="element-84">
            <h1 className="text-6xl md:text-8xl font-bold mb-6 leading-tight text-[#FFB5C5]" data-id="element-85">
              Audio <br data-id="element-86" />
              Guest Book
            </h1>
            <p className="text-xl md:text-2xl font-light text-gray-300 mb-8 max-w-md" data-id="element-87">
              Capture the voices of your loved ones. A vintage telephone audio
              guest book for your special day.
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-88">
              <Button variant="primary" icon onClick={scrollToBooking} data-id="element-89">
                Check Availability
              </Button>
              <a href="mailto:mybeepbook@gmail.com" data-id="element-90">
                <Button variant="outline" className="border-white text-white hover:bg-white hover:text-black" data-id="element-91">
                  Contact Us
                </Button>
              </a>
            </div>
          </div>

          <div className="relative" data-id="element-92">
            <div className="grid grid-cols-2 gap-4" data-id="element-93">
              <div className="space-y-4 mt-12" data-id="element-94">
                <img src="https://images.unsplash.com/photo-1520342868574-5fa3804e551c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Vintage phone" className="rounded-2xl shadow-2xl w-full h-64 object-cover transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-95" />
                <img src="https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Wedding couple" className="rounded-2xl shadow-2xl w-full h-48 object-cover transform rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-96" />
              </div>
              <div className="space-y-4" data-id="element-97">
                <img src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Wedding party" className="rounded-2xl shadow-2xl w-full h-48 object-cover transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-98" />
                <img src="https://images.unsplash.com/photo-1523438885200-e635ba2c371e?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Vintage decor" className="rounded-2xl shadow-2xl w-full h-64 object-cover transform -rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-99" />
              </div>
            </div>

            {/* Decorative circle */}
            <div className="absolute -z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[#FFB5C5] opacity-10 rounded-full blur-3xl" data-id="element-100"></div>
          </div>
        </div>
      </div>
    </section>;
}